import axios from 'axios';

export const clientProducerFarmApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-producer-farm`,
    headers: {
        'Content-Type': 'application/json'
    }
})